import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { enumerationNumber } from '@models/types';
import { SectionParamsModel } from './SectionParamsModel';
import { SectionTypeEnum } from '@api';
import { SectionItemListTypeEnum } from '@constants';
import {
  TutorialCourseItemType,
  TutorialCourseUnionType,
} from './TutorialCourseUnionType';

export class Section extends Model({
  type: enumerationNumber([
    SectionTypeEnum.Latest,
    SectionTypeEnum.Recommended,
    SectionTypeEnum.Popular,
    SectionTypeEnum.Tag,
    SectionTypeEnum.Saved,
    SectionTypeEnum.History,
    SectionTypeEnum.Section,
    SectionTypeEnum.Courses,
  ]),
  name: types.string,
  params: types.maybeNull(SectionParamsModel),

  items: types.array(TutorialCourseUnionType),
}) {
  get sectionType() {
    switch (this.type) {
      case SectionTypeEnum.Latest:
        return SectionItemListTypeEnum.Latest;
      case SectionTypeEnum.Recommended:
        return SectionItemListTypeEnum.Recommended;
      case SectionTypeEnum.Popular:
        return SectionItemListTypeEnum.Popular;
      case SectionTypeEnum.Tag:
        return SectionItemListTypeEnum.Tag;
      case SectionTypeEnum.Courses:
        return SectionItemListTypeEnum.Courses;
      case SectionTypeEnum.Saved:
        return SectionItemListTypeEnum.Saved;
      case SectionTypeEnum.History:
        return SectionItemListTypeEnum.History;
      case SectionTypeEnum.Section:
        return SectionItemListTypeEnum.Section;
      default:
        return SectionItemListTypeEnum.Latest;
    }
  }

  get content(): {
    type: SectionTypeEnum;
    data: TutorialCourseItemType[];
  } {
    return {
      type: this.type,
      data: this.items.slice(),
    };
  }

  get preview() {
    return this.content.data.slice(0, 10);
  }
}

export const SectionModel = model(Section);
